import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { DashboardKpiTimeRange } from '../../enums/dashboard-kpi-time-range.enum';
import { DashboardKpis } from '../../interfaces/dashboard-kpis.interface';
import * as DashboardKpisActions from './dashboard-kpis.actions';

export const dashboardKpisFeatureKey = 'dashboardKpis';

export interface State {
  dashboardKpis: DashboardKpis | null;
  timeRange: DashboardKpiTimeRange;
  loading: boolean;
  error: unknown;
}

export const initialState: State = {
  dashboardKpis: null,
  timeRange: DashboardKpiTimeRange.THIRTY_DAYS,
  loading: false,
  error: null,
};

export const dashboardKpisReducer = createReducer(
  initialState,
  on(DashboardKpisActions.loadDashboardKpis, (state, action) => ({
    ...state,
    timeRange: action.timeRange,
    loading: true,
    error: null,
  })),
  on(DashboardKpisActions.loadDashboardKpisSuccess, (state, action) => ({
    ...state,
    dashboardKpis: action.dashboardKpis,
    loading: false,
  })),
  on(DashboardKpisActions.loadDashboardKpisFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
  })),
  on(DashboardKpisActions.clearDashboardKpis, () => initialState)
);

export const selectDashboardKpisState = createFeatureSelector<State>(
  dashboardKpisFeatureKey
);

export const selectDashboardKpis = createSelector(
  selectDashboardKpisState,
  (state) => state.dashboardKpis
);

export const selectDashboardKpisLoading = createSelector(
  selectDashboardKpisState,
  (state) => state.loading
);

export const selectDashboardKpiTimeRange = createSelector(
  selectDashboardKpisState,
  (state) => state.timeRange
);
